









import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    CallHistory: () => import('@/components/call/CallHistory.vue'),
    CallUserSearch: () => import('@/components/call/CallUserSearch.vue')
  }
})
export default class CallUserSelect extends Vue {
  $store!: ExStore

  created() {
    this.$store.dispatch('team/fetchTeamMembers')
  }

  beforeDestroy() {
    this.$store.commit('call/updateCallPartners', [])
  }
}
